import clone from 'clone';

/**
 * mutates the permissions.products property with the data given, as-is
 */
export const getProductPermissions = (state, data) => {
  state.permissions.products = clone(data);
};
